import _ from 'underscore';
import { Component } from 'react';
import styled from 'styled-components';
import pluralize from 'pluralize';
import { academyCustomCSS } from '~/constants/academyCustomCSS';
import { media, theme } from '../../../styles';
import TimeUtils from '../../../common/time-utils';

export default class AcademyLearnerStats extends Component {
  render() {
    const filteredStats = _.filter(this.props.stats, (stat) => {
      if (
        (stat.valueType === APP_CONSTANTS.ACADEMY_STAT_TYPES.INTEGER && stat.value === 0) ||
        (stat.valueType === APP_CONSTANTS.ACADEMY_STAT_TYPES.STRING && stat.value === '') ||
        (stat.valueType === APP_CONSTANTS.ACADEMY_STAT_TYPES.SECONDS && stat.value === 0)
      ) {
        return false;
      }
      return true;
    });
    const stats = filteredStats.map((stat) => (
      <LearnerStatBlock
        key={`${stat.label}-${stat.value}`}
        color={this.props.color}
        className={`stat-wrapper ${academyCustomCSS.header.bannerStat}`}
      >
        <LearnerStatNumber className="stat-value">{this.parseValue(stat.valueType, stat.value)}</LearnerStatNumber>
        <LearnerStatName className="stat-label">
          {this.parseLabel(stat.valueType, stat.label, stat.value)}
        </LearnerStatName>
      </LearnerStatBlock>
    ));

    return (
      <LearnerStats
        className={`stats-wrapper ${academyCustomCSS.header.bannerStatsWrapper}`}
        color={this.props.color}
        textAlign={this.props.textAlign}
      >
        {stats}
      </LearnerStats>
    );
  }

  parseValue = (valueType, value) => {
    switch (valueType) {
      case APP_CONSTANTS.ACADEMY_STAT_TYPES.SECONDS:
        return TimeUtils.displayDurationMedium(value);
      default:
        return value;
    }
  };

  parseLabel = (valueType, label, value) => {
    switch (valueType) {
      case APP_CONSTANTS.ACADEMY_STAT_TYPES.INTEGER:
        return pluralize(label, value);
      default:
        return label;
    }
  };
}

const LearnerStats = styled.div`
  display: flex;
  color: ${(props) => props.color};
  margin: 1.5rem 0;
  ${(props) => props.textAlign === 'center' && 'justify-content: center; text-align: center;'}
  ${(props) => props.textAlign === 'right' && 'justify-content: flex-end; text-align: right;'}
  flex-wrap: wrap;
  align-items: flex-start;
`;

const LearnerStatBlock = styled.div`
  padding: 10px 25px;
  border-right: solid 1px ${(props) => props.color};
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    border: none;
    padding-right: 0;
  }
  display: flex;
  flex-flow: column;
  justify-content: center;
  ${media.mobile} {
    flex-basis: 100%;
    border: none;
    border-bottom: solid 1px ${(props) => props.color};
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;

const LearnerStatNumber = styled.div`
  font-size: 2.5rem;
  line-height: 2.5rem;
  ${theme.font.bold}
`;

const LearnerStatName = styled.div`
  font-size: 0.875rem;
`;
